import { FetchAPI, ParamsSerializer } from './auth-service';

class ClusterDataService {
    constructor () {
        // we only need one of these
        if (!ClusterDataService.instance) {
            ClusterDataService.instance = this;
        }
        this.searchPlaceholder = 'Search indices';

        this.addNode = node => {
            return FetchAPI({
                method: 'POST',
                url: 'datanodes/',
                body: node
            });
        };

        this.deleteNode = ip => {
            return FetchAPI({
                method: 'DELETE',
                url: `datanodes/${ip}`,
            });
        };

        this.deleteIndex = name => {
            return FetchAPI({
                method: 'PUT',
                url: `es/delete-index/${name}`,
            });
        };

        this.reregisterNode = ip => {
            return FetchAPI({
                method: 'PUT',
                url: `datanodes/${ip}/reregister`,
            });
        };

        this.setNodeRole = (host, instance, role, enable) => {
            return FetchAPI({
                method: 'PUT',
                url: `datanodes/${host}/${instance}/roles/${role}`,
                body: {
                    enable
                }
            });
        };

        this.getSavedSearches = () => {
            try {
                let searches = localStorage.getItem('savedSearches_cluster_indices') || '[]';
                if (searches.length < 1) searches = '[]';
                return JSON.parse(searches);
            } catch (err) {
                console.log('getSavedSearches error', err);
                return [];
            }
        };

        this.saveSearch = (str) => {
            if (!str || !str.length) return;
            const searches = this.getSavedSearches();
            const i = searches.findIndex(s => s === str);
            if (i >= 0) searches.splice(i, 1);
            searches.unshift(str);
            searches.splice(5);
            localStorage.setItem('savedSearches_cluster_indices', JSON.stringify(searches));
        };

        this.setElasticPassword = () => {
            return FetchAPI({
                method: 'POST',
                url: 'system/-run-es-password'
            });
        };

        this.startMigration = () => {
            return FetchAPI({
                method: 'POST',
                url: 'system/opensearch-migration/-migrate',
            });
        };

        this.getMigrationLog = () => {
            return FetchAPI({
                method: 'GET',
                url: 'system/opensearch-migration/log',
            });
        };

        this.ackMigration = () => {
            return FetchAPI({
                method: 'POST',
                url: 'system/opensearch-migration/-acknowledge',
            });
        };

        return ClusterDataService.instance;
    }
}

const ClusterService = new ClusterDataService();

export default ClusterService;
